// document.addEventListener("DOMContentLoaded", () => {
//   const popup = document.querySelector('[data-mystery-popup]');
//   if (!popup) return;

//   const addToCartButton = document.querySelector('add-to-cart-component button');
//   const addToCartButtonHome = document.querySelector('.ai-product-add-to-cart');

//   if (addToCartButton) {
//     addToCartButton.addEventListener(
//       "click",
//       function (e) {
//         e.preventDefault();
//         e.stopImmediatePropagation();
//         e.stopPropagation();

//         popup.classList.add("active");
//       },
//       true
//     );
//   }
//   if (addToCartButtonHome) {
//     addToCartButtonHome.addEventListener(
//       "click",
//       function (e) {
//         e.preventDefault();
//         e.stopImmediatePropagation();
//         e.stopPropagation();

//         popup.classList.add("active");
//       },
//       true
//     );
//   }

//   // Close popup
//   const overlay = popup.querySelector(".mystery-overlay");
//   const closeBtn = popup.querySelector(".mystery-close");

//   overlay.addEventListener("click", () => popup.classList.remove("active"));
//   closeBtn.addEventListener("click", () => popup.classList.remove("active"));
//   const maxAllowed = 3;
//   const checkboxes = document.querySelectorAll(".limit-checkbox");

//   checkboxes.forEach(function (checkbox) {
//     checkbox.addEventListener("change", function () {
//       const checkedBoxes = document.querySelectorAll(".limit-checkbox:checked");

//       if (checkedBoxes.length > maxAllowed) {
//         this.checked = false;
//         alert("Unfortunately, you can pick up to three options only — choose your favorites!");
//       }
//     });
//   });

//   const form = popup.querySelector("#mystery-form");

//   form.addEventListener("submit", async (e) => {
//     e.preventDefault();

//     // Validate required fields
//     const requiredFields = form.querySelectorAll("[required]");
//     for (let field of requiredFields) {
//       if (!field.value.trim()) {
//         alert(`Please fill "${field.name}"`);
//         field.focus();
//         return;
//       }
//     }

//     try {
//       const res = await fetch("/cart/add.js", {
//         method: "POST",
//         body: new FormData(form),
//         headers: { Accept: "application/json" },
//       });

//       if (res.ok) {
//         // Close popup
//         popup.classList.remove("active");

//         // ✅ Guaranteed redirect to cart page
//         setTimeout(() => {
//           window.location.assign("/cart");
//         }, 50); // slight delay ensures fetch completes
//       } else {
//         const err = await res.json();
//         alert(err.description || "Failed to add product to cart");
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Something went wrong. Please try again.");
//     }
//   });
// });


document.addEventListener("DOMContentLoaded", () => {

  const popup = document.querySelector('[data-mystery-popup]');
  if (!popup) return;

  const variantInput = document.querySelector("#mystery-variant-id");
  const form = popup.querySelector("#mystery-form");

  let selectedVariant = null;

  /* =========================
     OPEN POPUP ON ADD TO CART
  ==========================*/
  document.addEventListener("click", function (e) {

    const productBtn = e.target.closest("add-to-cart-component button");
    const homeBtn = e.target.closest('[class*="ai-product-add-to-cart"]');
    const btn = productBtn || homeBtn;

    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    /* Detect variant id from clicked button */
    selectedVariant =
      btn.dataset.variantId ||
      btn.dataset.productVariantId ||
      btn.getAttribute("data-id");

    /* Inject variant id if found */
    if (variantInput && selectedVariant) {
      variantInput.value = selectedVariant;
    }

    popup.classList.add("active");

  }, true);

  /* =========================
     CLOSE POPUP
  ==========================*/
  const overlay = popup.querySelector(".mystery-overlay");
  const closeBtn = popup.querySelector(".mystery-close");

  if (overlay) overlay.addEventListener("click", () => popup.classList.remove("active"));
  if (closeBtn) closeBtn.addEventListener("click", () => popup.classList.remove("active"));

  /* =========================
     LIMIT CHECKBOXES
  ==========================*/
  const maxAllowed = 3;
  const checkboxes = document.querySelectorAll(".limit-checkbox");

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      const checked = document.querySelectorAll(".limit-checkbox:checked");
      if (checked.length > maxAllowed) {
        this.checked = false;
        alert("You can pick up to three options only — choose your favorites!");
      }
    });
  });

  /* =========================
     FORM SUBMIT
  ==========================*/
  if (!form) return;

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    // Validate required fields
    const requiredFields = form.querySelectorAll("[required]");
    for (let field of requiredFields) {
      if (!field.value.trim()) {
        alert(`Please fill "${field.name}"`);
        field.focus();
        return;
      }
    }

    const formData = new FormData(form);

    // Add variant ID
    if (selectedVariant && variantInput) {
      formData.set("id", selectedVariant);
    }

    // ✅ Add quantity
    const quantityInput = form.querySelector('input[name="quantity"]');
    if (quantityInput) {
      formData.set("quantity", quantityInput.value || 1);
    }

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: { Accept: "application/json" },
      });

      if (res.ok) {
        popup.classList.remove("active");
        // redirect to cart page
        setTimeout(() => window.location.assign("/cart"), 50);
      } else {
        const err = await res.json();
        alert(err.description || "Failed to add product to cart");
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Please try again.");
    }
  });
  const sliders = document.querySelectorAll(".mobile-slider");

  const isMobile = () => window.innerWidth <= 768;

  // sliders.forEach((slider) => {
  //   let initialized = false;

  //   const initSlider = () => {
  //     if (!isMobile() || initialized) return;

  //     const items = Array.from(slider.children);
  //     if (items.length < 2) return;

  //     initialized = true;

  //     // Clone items
  //     const firstClones = items.map(el => el.cloneNode(true));
  //     const lastClones = items.map(el => el.cloneNode(true));

  //     firstClones.forEach(clone => slider.appendChild(clone));
  //     lastClones.reverse().forEach(clone => slider.insertBefore(clone, slider.firstChild));

  //     const itemWidth = items[0].offsetWidth + 12;
  //     slider.scrollLeft = itemWidth * items.length;

  //     slider.addEventListener("scroll", () => {
  //       if (!isMobile()) return;

  //       const maxScroll = slider.scrollWidth - slider.clientWidth;

  //       if (slider.scrollLeft >= maxScroll - itemWidth) {
  //         slider.scrollLeft = itemWidth * items.length;
  //       }

  //       if (slider.scrollLeft <= itemWidth) {
  //         slider.scrollLeft = itemWidth * items.length;
  //       }
  //     });
  //   };

  //   const destroySlider = () => {
  //     if (isMobile() || !initialized) return;

  //     // Reload is simplest safe reset (avoids duplicate clones issue)
  //     location.reload();
  //   };

  //   // Run on load
  //   initSlider();

  //   // Run on resize
  //   window.addEventListener("resize", () => {
  //     if (isMobile()) {
  //       initSlider();
  //     } else {
  //       destroySlider();
  //     }
  //   });
  // });

});